export default __webpack_public_path__ + "static/media/cuti1.ec3c581c.png";